import { environment } from '@/common/constant/constants';

const LEADJOURNEY_SCRIPT_URL = 'https://t.gorelo.io/package/latest/a2474898-3236-4cf5-a935-5aa8fb488a39/';

let isInitialized = false;

export function initLeadJourney() {
    // Only run LeadJourney tracking in production
    if (environment !== 'production') {
        return;
    }

    if (isInitialized) {
        return;
    }
    isInitialized = true;

    function loadScript() {
        try {
            const script = document.createElement('script');
            script.src = LEADJOURNEY_SCRIPT_URL;
            script.async = true;
            script.setAttribute('fetchpriority', 'low');
            script.onerror = () => console.warn('Failed to load LeadJourney tracking script');
            document.head.appendChild(script);
        } catch (e) {
            console.error('Failed to initialize LeadJourney', e);
        }
    }

    // Deferred until after window load so it never competes with the app's
    // own critical-path requests/main-thread work during initial boot.
    if (document.readyState === 'complete') {
        loadScript();
    } else {
        window.addEventListener('load', loadScript, { once: true });
    }
}
